import { LitElement, html, css } from 'lit'

class Popover extends LitElement {
  static styles = css`
    .info-box {
      --icon-width: 1.5em;

      align-items: center;
      margin-bottom: var(--spacing-6);
      border-radius: 4px;
      background-color: hsl(var(--gray-400));
      color: hsl(var(--white));
      padding: var(--spacing-3) var(--spacing-3) var(--spacing-4);

      circle-exclamation-icon {
        margin-right: var(--spacing-3);
      }
    }

    .tooltip-toggle {
      --icon-width: 1.5rem;

      cursor: pointer;
      position: relative;
      margin-left: var(--spacing-3);

      &:focus-visible {
        --outline-offset: 2px;
        outline: var(--outline);
        outline-offset: var(--outline-offset);
        border-radius: var(--outline-radius);
      }
    }

    .tooltip-toggle + .tooltip {
      z-index: 2;
      visibility: hidden;
      position: absolute;
      right: 0;
      top: 1.8rem;
      max-width: 300px;
      border-radius: 4px;
      background-color: hsl(var(--gray-400));
      color: hsl(var(--white));
      padding: var(--spacing-3) var(--spacing-3) var(--spacing-4);
      transition: opacity 0.2s ease-out;
    }

    .tooltip-toggle:hover + .tooltip,
    .tooltip-toggle:focus + .tooltip,
    .tooltip:hover,
    .tooltip:focus {
      visibility: visible;
    }

    .tooltip-hidden {
      visibility: hidden !important;
    }

    .tooltip-toggle::after {
      content: '';
      position: absolute;
      top: 1.2rem;
      left: 12px;
      transform: translateX(-50%);
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent hsl(var(--gray-400)) transparent;
      opacity: 0;
    }

    .tooltip-toggle:hover::after,
    .tooltip-toggle:focus::after,
    .tooltip-wrapper:has(.tooltip:hover) .tooltip-toggle::after,
    .tooltip-wrapper:has(.tooltip:focus) .tooltip-toggle::after {
      opacity: 1;
      visibility: visible;
      transition: opacity 0.1s ease-out;
    }
  `

  constructor() {
    super()
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFocusOut = this.handleFocusOut.bind(this)
    this.removeClassName = this.removeClassName.bind(this)
  }

  firstUpdated() {
    this.tooltipToggle = this.shadowRoot.querySelector('.tooltip-toggle')
    this.tooltip = this.shadowRoot.querySelector('.tooltip')

    document.addEventListener('keydown', this.handleKeyDown)
    this.tooltipToggle.addEventListener('focus', this.removeClassName)
    this.tooltipToggle.addEventListener('focusout', this.handleFocusOut)
    this.tooltip.addEventListener('focusout', this.handleFocusOut)
    this.tooltipToggle.addEventListener('mouseleave', this.removeClassName)
    this.tooltipToggle.addEventListener('mouseenter', this.removeClassName)
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.tooltip.classList.add('tooltip-hidden')
    }
  }

  removeClassName() {
    this.tooltip.classList.remove('tooltip-hidden')
  }

  handleFocusOut(event) {
    if (
      !this.tooltip.contains(event.relatedTarget) &&
      !this.tooltipToggle.contains(event.relatedTarget)
    ) {
      this.tooltip.classList.remove('tooltip-hidden')
    }
  }

  render() {
    return html`
      <div
        class="tooltip-wrapper"
        aria-label="${this.getAttribute('data-aria-label')}"
      >
        <div
          tabindex="0"
          class="tooltip-toggle"
          aria-describedby="popover-content"
        >
          <slot name="icon"></slot>
        </div>
        <div id="popover-content" role="tooltip" class="tooltip">
          <slot name="content"></slot>
        </div>
      </div>
    `
  }
}
customElements.define('popover-box', Popover)
